import * as React from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { add } from "../../service/clientService";
import { Button } from "primereact/button";
import DropdownApi from "../../components/DropdownApi";
import { UserSession } from "../../models/UserSession";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import { addEmployee, updateEmployee } from "../../service/employeeService";
import { apiGet, NprLookup } from "../../service/api-service";
import S3ImagePreview from "../../components/S3ImagePreview";
import { Avatar } from "primereact/avatar";
import { placeholder } from "../../assets/placeholder";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import ImageS3Upload from "../../components/ImageS3Upload";
import { v4 as uuid } from "uuid";
import { Steps } from "primereact/steps";
import { Grid } from "@mui/material";
import { userIDNumberCheck } from "../../service/configService";
import { AlternateEmailOutlined } from "@mui/icons-material";
import { InputText } from "primereact/inputtext";
import { USAGE_TYPE_ENUM } from "../billing/common";
import { Dropdown } from "primereact/dropdown";
import { s3UploadFileImage } from "../../service/s3Service";
import MobileValidationApi from "../../components/MobileValidationApi";
import EmailValidationApi from "../../components/EmailValidationApi";

export default function EmployeeAdd(modalProps: any) {
  const record = modalProps.record;

  const id = modalProps?.uuid;

  async function EmployeeAdd() {
    let createObject: any = {
      client_id: clientId,
      name,
      surname,
      id_number: idNumber,
      email: email,
      mobile: mobile,
      appointment,
      title,
      npr_lookup: nprLookup,
      s3_key: !!file ? `employee/profile/${id}` : undefined,
      employee_number: employeeNumber,
      next_of_kin_name: nextOfKinName,
      next_of_kin_surname: nextOfKinSurname,
      next_of_kin_cell: nextOfKinCell,
      next_of_kin_email: nextOfKinEmail,
      gender,
    };
    const signatureUrl = await createSignature();
    if (signatureUrl) {
      createObject.signature_s3_key = signatureUrl;
    }
    modalProps.setGlobalLoading(true);
    if (record?.id) {
      updateEmployee(createObject, record.id).then((r: any) => {
        modalProps.setGlobalLoading(false);
        modalProps.toast.current.show({
          severity: "success",
          summary: "Employee Updated Successfully",
          life: 3000,
        });
        modalProps.setReload(!modalProps.reload);
        modalProps.setVisible(false);
      });
      return;
    }
    addEmployee(createObject).then((r: any) => {
      modalProps.setGlobalLoading(false);
      modalProps.toast.current.show({
        severity: "success",
        summary: "Employee Added Successfully",
        life: 3000,
      });
      modalProps.setReload(!modalProps.reload);
      modalProps.setVisible(false);
    });
  }

  async function back() {
    setActiveIndex(activeIndex - 1);
  }

  async function createSignature() {
    if (record?.signature_s3_key && record?.signature_s3_key !== '') {
      return undefined;
    }
    const link = `employee/signature/${uuid()}`;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    canvas.width = 400;
    canvas.height = 150;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.font = "48px 'Dancing Script', cursive";
    ctx.fillStyle = "black";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    ctx.fillText(`${name} ${surname}`, canvas.width / 2, canvas.height / 2);

    const signatureUrl = canvas.toDataURL("image/png");

    await s3UploadFileImage(link, signatureUrl);

    return link;
  };

  async function next() {
    // if (activeIndex == 0 && !!idNumber) {
    //   modalProps.setGlobalLoading(true);
    //   const user = await userIDNumberCheck(idNumber);
    //   if (user?.id) {
    //     setUser(user.id);
    //     setName(user.given_name);
    //     setSurname(user.family_name);
    //     setPhoto(user.photo_url);
    //     setEmail(user.email);
    //     setMobile(user.phone_number);
    //   }
    //   modalProps.setGlobalLoading(false);
    // }
    if (activeIndex == 2 && (!mobile || mobile === "+27")) {
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Please enter a valid mobile number.",
        life: 3000,
      });
      return;
    }
    setActiveIndex(activeIndex + 1);
  }

  async function getPricingData() {
    modalProps.setGlobalLoading(true);
    try {
      const response = await apiGet("core", "billing/pricing");
      const prices = response.content || [];
      const activeNPRLookup = prices.find(
        (e: any) => e.active && e.usage_type == USAGE_TYPE_ENUM.Home_Affairs_Lookup
      );
      if (activeNPRLookup?.id) {
        setNprLookupPrice(parseFloat(activeNPRLookup.cost_client_per_unit).toFixed(2));
      }
      console.log("Pricing data:", prices);
    } catch (error) {
      console.error("Error fetching pricing data:", error);
    } finally {
      modalProps.setGlobalLoading(false);
    }
  }

  async function EmployeeVerifyID() {
    modalProps.setGlobalLoading(true);
    NprLookup(idNumber).then((r: any) => {
      if (!r.idNumber) {
        setValidIdNumber(false);
        return;
      }
      setNprLookup(true);
      setFile(undefined);
      setValidIdNumber(true);
      setFullName(`${r.name} ${r.surname}`);
      setName(r.name);
      setSurname(r.surname);
      setPhoto(r.photo);
      setDateOfDeath(r.dateOfDeath);
      setDateOfMarriage(r.dateOfMarriage);
      setDateTimeOfMarriage(r.dateTimeOfMarriage);
      setDeadIndicator(r.deadIndicator);
      setIdBlocked(r.idBlocked);
      setIdIssueDate(r.idIssueDate);
      setMaritalStatus(r.maritalStatus);
      setBirthPlaceCountry(r.birthPlaceCountry);
      setBirthPlaceCountryCode(r.birthPlaceCountryCode);
      setPhotoGuid(r.photoGuid);
      setSmartCardIssued(r.smartCardIssued);
      setTransactionNo(r.transactionNo);
      console.log("EmployeeVerifyID == ", r);
      modalProps.setGlobalLoading(false);
      next();
    });
  }

  React.useEffect(() => {
    getPricingData();
  }, []);

  const session: UserSession = modalProps.session;

  const [fullName, setFullName] = React.useState(record?.full_name || "");
  const [name, setName] = React.useState(record?.name || "");
  const [surname, setSurname] = React.useState(record?.surname || "");
  const [employeeNumber, setEmployeeNumber] = React.useState(record?.employee_number || "");
  const [gender, setGender] = React.useState(record?.gender || "");
  const [nextOfKinName, setNextOfKinName] = React.useState(record?.next_of_kin_name || "");
  const [nextOfKinSurname, setNextOfKinSurname] = React.useState(record?.next_of_kin_surname || "");
  const [nextOfKinCell, setNextOfKinCell] = React.useState(record?.next_of_kin_cell || "");
  const [nextOfKinEmail, setNextOfKinEmail] = React.useState(record?.next_of_kin_email || "");
  const [title, setTitle] = React.useState(record?.title || "");
  const [idNumber, setIdNumber] = React.useState(record?.id_number || "");
  const [validIdNumber, setValidIdNumber] = React.useState(false);
  const [clientId, setClientId] = React.useState(session?.client_id || "");
  const [mobile, setMobile] = React.useState(record?.mobile || "");
  const [email, setEmail] = React.useState(record?.email || "");
  const [dateOfDeath, setDateOfDeath] = React.useState(record?.date_of_death || "");
  const [dateOfMarriage, setDateOfMarriage] = React.useState(record?.date_of_marriage || "");
  const [dateTimeOfMarriage, setDateTimeOfMarriage] = React.useState(
    record?.date_time_of_marriage || ""
  );
  const [deadIndicator, setDeadIndicator] = React.useState(record?.dead_indicator || "");
  const [idBlocked, setIdBlocked] = React.useState(record?.id_blocked || "");
  const [birthPlaceCountry, setBirthPlaceCountry] = React.useState(
    record?.birth_place_country || ""
  );
  const [birthPlaceCountryCode, setBirthPlaceCountryCode] = React.useState(
    record?.birth_place_country_code || ""
  );
  const [idIssueDate, setIdIssueDate] = React.useState(record?.id_issue_date || "");
  const [maritalStatus, setMaritalStatus] = React.useState(record?.marital_status || "");
  const [photoGuid, setPhotoGuid] = React.useState(record?.photo_guid || "");
  const [smartCardIssued, setSmartCardIssued] = React.useState(record?.smart_card_issued || false);
  const [transactionNo, setTransactionNo] = React.useState(record?.transaction_no || "");
  const [appointment, setAppointment] = React.useState(record?.appointment || "");
  const [nprLookup, setNprLookup] = React.useState(record?.npr_lookup || false);
  const [user, setUser] = React.useState(record?.user || "");
  const [photo, setPhoto] = React.useState(record?.photo || placeholder);
  const [file, setFile] = React.useState<File>();
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [nprLookupPrice, setNprLookupPrice] = React.useState("0");

  const [mobileValidationMessage, setMobileValidationMessage] = React.useState("");
  const [mobileValidationStatus, setMobileValidationStatus] = React.useState<'success' | 'warning' | 'error' | ''>('');
  const [mobileLoading, setMobileLoading] = React.useState(false);


  const [emailValidationMessage, setEmailValidationMessage] = React.useState("");
  const [emailValidationStatus, setEmailValidationStatus] = React.useState<'success' | 'warning' | 'error' | ''>('');
  const [emailLoading, setEmailLoading] = React.useState(false);

  const canvasRef = React.useRef<HTMLCanvasElement | null>(null);

  const genders = [{ name: "Male" }, { name: "Female" }];

  const stepItems = [
    {
      label: "ID Number",
    },
    {
      label: "ID Verification",
    },
    {
      label: "Contact Details",
    },
    {
      label: "Employee Details",
    },
    {
      label: "Home Affairs Info",
    },
    {
      label: "Appointments",
    },
  ];

  return (
    <React.Fragment>
      <Steps readOnly model={stepItems} activeIndex={activeIndex} />
      <br />
      {activeIndex == 0 ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl sx={{ flexGrow: 1 }}>
              <FormLabel>
                ID Number <div style={{ color: "red" }}>*</div>
              </FormLabel>
              <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                <Input
                  value={idNumber}
                  size="sm"
                  placeholder="ID Number"
                  onChange={e => setIdNumber(e.target.value)}
                />
              </FormControl>
            </FormControl>
          </Grid>
        </Grid>
      ) : (
        ""
      )}
      {activeIndex == 1 ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormLabel>
              Would you like to retrieve the person's information from the South African Department
              of Home Affairs?
            </FormLabel>
            <br />
            <FormLabel>
              Selected data of the individual as stored by the South African Department of Home
              Affairs will be made available for verification and pre-population if the ID provided
              is a valid South African ID.
            </FormLabel>
            <br />
            <FormLabel>
              Please note: Each successful lookup carries a cost of R{nprLookupPrice} and is subject
              to change without prior notice
            </FormLabel>
            <br />
            <FormLabel>Or Cancel and enter the details manually</FormLabel>
          </Grid>
          <Grid item>
            <Button
              type="button"
              icon="pi pi-verified"
              label="Verify ID"
              className="p-button-outlined"
              size="small"
              style={{ fontSize: "small", color: "#2dd36f" }}
              onClick={() => EmployeeVerifyID()}
            />
          </Grid>
          <Grid item>
            <Button
              type="button"
              icon="pi pi-times-circle"
              label="Cancel"
              className="p-button-outlined"
              size="small"
              style={{ fontSize: "small", color: "#c5000f" }}
              onClick={() => next()}
            />
          </Grid>
        </Grid>
      ) : (
        ""
      )}
      {activeIndex == 2 ? (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
              <FormLabel style={{ marginBottom: 10 }}>Name</FormLabel>
              <InputText
                value={name}
                onChange={e => setName(e.target.value)}
                type="text"
                className="p-inputtext-sm PrimeSmallInput"
                placeholder="Please enter name"
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
              <FormLabel style={{ marginBottom: 10 }}>Surname</FormLabel>
              <InputText
                value={surname}
                onChange={e => setSurname(e.target.value)}
                type="text"
                className="p-inputtext-sm PrimeSmallInput"
                placeholder="Please enter surname"
              />
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <MobileValidationApi
              label="Mobile"
              type="Employee"
              mobile={mobile}
              setMobile={setMobile}
              required
              validationMessage={mobileValidationMessage}
              setValidationMessage={setMobileValidationMessage}
              validationStatus={mobileValidationStatus}
              setValidationStatus={setMobileValidationStatus}
              loading={mobileLoading}
              setLoading={setMobileLoading}
            />

            <div
              style={{
                fontSize: "small",
                color: "#e65100",
                backgroundColor: "#fff3e0",
                border: "1px solid #ffcc02",
                borderRadius: "4px",
                padding: "8px 12px",
                marginTop: "8px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <span style={{ fontSize: "14px" }}>⚠️</span>
              <span>
                <strong>Important:</strong> Please ensure this mobile number is correct as it will
                be used by the employee to log into the DSF App.
              </span>
            </div>
          </Grid>
          <Grid item xs={6}>
            <EmailValidationApi
              label="Email"
              email={email}
              setEmail={setEmail}
              type="Employee"
              validationMessage={emailValidationMessage}
              validationStatus={emailValidationStatus}
              setValidationMessage={setEmailValidationMessage}
              setValidationStatus={setEmailValidationStatus}
              loading={emailLoading}
              setLoading={setEmailLoading}
            />
          </Grid>
        </Grid>
      ) : (
        ""
      )}
      {activeIndex == 3 ? (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
              <FormLabel style={{ marginBottom: 10 }}>Employee Number</FormLabel>
              <InputText
                value={employeeNumber}
                onChange={e => setEmployeeNumber(e.target.value)}
                type="text"
                className="p-inputtext-sm PrimeSmallInput"
                placeholder="Please enter Employee Number"
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
              <FormLabel style={{ marginBottom: 10 }}>Gender</FormLabel>
              <Dropdown
                className="PrimeSmallInput custom-dropdown"
                style={{ fontSize: "small", padding: 0 }}
                onChange={(e: any) => setGender(e.value)}
                value={gender}
                options={genders}
                optionLabel="name"
                optionValue="name"
                filter
                showClear
                filterBy="name"
                placeholder={`Select a Gender`}
                panelClassName="custom-dropdown-panel"
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
              <FormLabel style={{ marginBottom: 10 }}>Next Of Kin Name</FormLabel>
              <InputText
                value={nextOfKinName}
                onChange={e => setNextOfKinName(e.target.value)}
                type="text"
                className="p-inputtext-sm PrimeSmallInput"
                placeholder="Please enter name"
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
              <FormLabel style={{ marginBottom: 10 }}>Next Of Kin Surname</FormLabel>
              <InputText
                value={nextOfKinSurname}
                onChange={e => setNextOfKinSurname(e.target.value)}
                type="text"
                className="p-inputtext-sm PrimeSmallInput"
                placeholder="Please enter surname"
              />
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
              <FormLabel style={{ marginBottom: 10 }}>Next Of Kin Mobile</FormLabel>
              <PhoneInput
                defaultCountry="za"
                value={nextOfKinCell}
                onChange={e => setNextOfKinCell(e)}
                inputStyle={{ width: "100%" }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
              <FormLabel style={{ marginBottom: 10 }}>Next Of Kin Email</FormLabel>
              <div className="p-inputgroup ">
                <span className="p-inputgroup-addon PrimeSmallInput">
                  <AlternateEmailOutlined />
                </span>
                <InputText
                  style={{ width: "100%" }}
                  value={nextOfKinEmail}
                  onChange={e => setNextOfKinEmail(e.target.value)}
                  type="text"
                  className="p-inputtext-sm PrimeSmallInput"
                  placeholder="Please email"
                />
              </div>
            </FormControl>
          </Grid>
        </Grid>
      ) : (
        ""
      )}
      {activeIndex == 4 ? (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl>
              <ImageS3Upload
                photo={photo}
                setPhoto={setPhoto}
                s3Key={`employee/profile/${id}`}
                file={file}
                setFile={setFile}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>ID Blocked</FormLabel>
                <Input
                  size="sm"
                  placeholder="Id Blocked"
                  value={idBlocked}
                  style={{ width: "100%" }}
                  readOnly
                  sx={{ flexGrow: 1 }}
                />
              </FormControl>
            </Grid>
            <br />
            <Grid item xs={12}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>Id Issue Date</FormLabel>
                <Input
                  size="sm"
                  placeholder="Id Issue Date"
                  value={idIssueDate}
                  style={{ width: "100%" }}
                  readOnly
                  sx={{ flexGrow: 1 }}
                />
              </FormControl>
            </Grid>
            <br />
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>IS Dead</FormLabel>
                <Input
                  size="sm"
                  placeholder="IS Dead"
                  value={deadIndicator}
                  readOnly
                  sx={{ flexGrow: 1 }}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        ""
      )}
      {activeIndex == 5 ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MultiDropdownApi
              apiPath="appointments"
              optionLabel="name"
              optionValue="id"
              label="Appointment"
              selectedData={appointment}
              setSelectedData={setAppointment}
            />
          </Grid>
        </Grid>
      ) : (
        ""
      )}
      <br />

      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          {activeIndex == 5 ? (
            <Button
              type="button"
              icon="pi pi-save"
              label="Save"
              className="p-button-outlined"
              size="small"
              style={{
                position: "absolute",
                fontSize: "small",
                right: 0,
                color: "#2dd36f",
              }}
              onClick={() => EmployeeAdd()}
            />
          ) : (
            <Button
              type="button"
              icon="pi pi-chevron-right"
              label="Next"
              className="p-button-outlined"
              disabled={
                !idNumber ||
                ((activeIndex == 2 && mobileValidationStatus !== 'success') || (activeIndex == 2 && mobileLoading)) ||
                ((activeIndex == 2 && emailValidationStatus !== 'success' && emailValidationStatus !== '' && email != '') || (activeIndex == 2 && emailLoading))
              }
              size="small"
              style={{ position: "absolute", fontSize: "small", right: 0 }}
              onClick={() => next()}
            />
          )}
          {activeIndex != 0 ? (
            <Button
              type="button"
              icon="pi pi-chevron-left"
              label="Back"
              className="p-button-outlined"
              size="small"
              style={{
                position: "absolute",
                fontSize: "small",
                right: 110,
                color: "#ffc409",
              }}
              onClick={() => back()}
            />
          ) : (
            ""
          )}
        </CardActions>
      </CardOverflow>
      <canvas ref={canvasRef} style={{ display: 'none' }} />
    </React.Fragment>
  );
}
